<template>
	<div class="rechargeManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">运营分析</div>
		</div>
		<div class="mainBot ">
			<div class="contentTop">
				<operationsStatistics @goUrl="goUrl"></operationsStatistics>
			</div>
			<div class="contentBot disBetween">
				<div class="contentLeft">
					<operationalOverview></operationalOverview>
				</div>
				<div class="contentRight">
					<rechargeStatistics></rechargeStatistics>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import operationalOverview from "./operationalOverview/operationalOverview.vue"
	import operationsStatistics from "./operationsStatistics/operationsStatistics.vue"
	import rechargeStatistics from "./rechargeStatistics/rechargeStatistics.vue"

	export default {
		name: "rechargeManage",
		components: {
			operationalOverview,
			operationsStatistics,
			rechargeStatistics
		},
		data() {
			return {

			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			getData() {},
			goUrl(str){
				this.$router.push({path: str,query:{}});
				this.$emit("setPath",str)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./operationsAnalysis.scss";
</style>